import React, { useEffect } from "react";

import {
  mdiArrowExpandHorizontal,
  mdiArrowExpandVertical,
  mdiArtboard,
} from "@mdi/js";
import Icon from "@mdi/react";
import { useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";

import Input from "../../form/Input";
import Select from "../../form/Select";

import type { JSX } from "react";

import type { ChannelSettingsFieldValues } from "../../../types";

export default function ChannelLogoPosition(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const { control, setValue } = useFormContext<ChannelSettingsFieldValues>();

  const [channelLogoWidth, aspectRatio] = useWatch({
    name: ["channelLogoWidth", "channelLogoAspectRatio"],
    control,
  });

  useEffect(() => {
    if (channelLogoWidth && aspectRatio) {
      const channelLogoHeight = Math.round(channelLogoWidth / aspectRatio);
      setValue("channelLogoHeight", channelLogoHeight);
    }
  }, [channelLogoWidth, aspectRatio, setValue]);

  const options = [
    { label: "Top Left", value: "top_left" },
    { label: "Top Right", value: "top_right" },
    { label: "Bottom Left", value: "bottom_left" },
    { label: "Bottom Right", value: "bottom_right" },
  ];

  return (
    <React.Fragment>
      <Select
        isRequired
        icon={<Icon path={mdiArtboard} size={0.9375} />}
        label={t("channelLogoPositionLabel")}
        name="channelLogoPosition"
        options={options}
        sublabel={t("channelLogoPositionSublabel")}
      />
      <Input
        isRequired
        icon={<Icon path={mdiArrowExpandHorizontal} size={0.9375} />}
        label={t("channelLogoWidthLabel")}
        min={1}
        name="channelLogoWidth"
        type="number"
      />
      <Input
        isReadOnly
        className="mb-[unset]"
        icon={<Icon path={mdiArrowExpandVertical} size={0.9375} />}
        label={t("channelLogoHeightLabel")}
        min={1}
        name="channelLogoHeight"
        type="number"
      />
    </React.Fragment>
  );
}
